// Icons Import
import { FaArrowRight } from "react-icons/fa"
import { Link } from "react-router-dom"

// Image and Video Import
import Banner from "../assets/Images/banner.mp4"
// Component Imports
import Footer from "../components/common/Footer"
import ReviewSlider from "../components/common/ReviewSlider"
import CTAButton from "../components/core/HomePage/Button"
import CodeBlocks from "../components/core/HomePage/CodeBlocks"
import ExploreMore from "../components/core/HomePage/ExploreMore"
import HighlightText from "../components/core/HomePage/HighlightText"
import InstructorSection from "../components/core/HomePage/InstructorSection"
import LearningLanguageSection from "../components/core/HomePage/LearningLanguageSection"
import TimelineSection from "../components/core/HomePage/Timeline"
import { useEffect, useState } from "react"
import ConfirmationModal from "../components/common/ConfirmationModal"
function Home() {
  
  const [confirmationModal,setConfirmationModal]=useState(null);
  useEffect(()=>{
    setConfirmationModal({
      text1: `Visit our free live test`,
      text2: "Check your Rank in Coochbehar",
      btn1Text: "Proceed",
      btn2Text: "Cancel",
      btn1Handler: () => {window.location.href="https://allcobexam.netlify.app/"},
      btn2Handler: () => setConfirmationModal(null),
    })
  },[])
  return (
    <div>
      {/* Section 1 */}
      <div className="relative mx-auto flex w-11/12 max-w-maxContent flex-col items-center justify-between gap-8 text-white">
        {/* Become a Instructor Button */}
        <Link to={"/signup"}>
          <div className="group mx-auto mt-16 w-fit rounded-full bg-richblack-800 p-1 font-bold text-richblack-200 drop-shadow-[0_1.5px_rgba(255,255,255,0.25)] transition-all duration-200 hover:scale-95 hover:drop-shadow-none">
            <div className="flex flex-row items-center gap-2 rounded-full px-10 py-[5px] transition-all duration-200 group-hover:bg-richblack-900">
              <p>Become an Instructor</p>
              <FaArrowRight />
            </div>
          </div>
        </Link>

        {/* Heading */}
        <div className="text-center text-4xl font-semibold">
          Empower Your Future with
          <HighlightText text={"PyVerse Academy"} />
        </div>

        {/* Sub Heading */}
        <div className="-mt-3 w-[90%] text-center text-lg font-bold text-richblack-300">
        <p>
At our coaching center, students learn
<span class="glass-tag">Mathematics</span>, 
<span class="glass-tag">Science</span>, 
<span class="glass-tag">Artificial Intelligence</span>, and 
<span class="glass-tag">Python Programming/IT/CS</span> 
through a structured and practical learning approach. Each subject is taught with clear concepts, step-by-step explanations, and dedicated study materials designed according to the students’ academic level. We conduct regular tests, quizzes, and practice sessions to track progress and strengthen understanding. Our courses also include hands-on projects, real-world examples, and problem-solving activities, helping students build strong analytical and coding skills. Students receive personalized guidance and feedback from experienced instructors, ensuring continuous improvement and academic success.
</p>

        </div>

        {/* CTA Buttons */}
        <div className="mt-8 flex flex-row gap-7">
          <CTAButton active={true} linkto={"https://allcobexam.netlify.app/"}>
            Live Test
          </CTAButton>
          <CTAButton active={false} linkto={"/login"}>
            Book a Demo Class
          </CTAButton>
        </div>

        {/* Video */}
        <div className="mx-3 my-7 shadow-[10px_-5px_50px_-5px] shadow-blue-200">
          <video
            className="shadow-[20px_20px_rgba(255,255,255)]"
            muted
            loop
            autoPlay
          >
            <source src={Banner} type="video/mp4" />
          </video>
        </div>

        {/* Code Section 1  */}
        <div>
          <CodeBlocks
            position={"lg:flex-row"}
            heading={
              <div className="text-4xl font-semibold">
                Unlock your
                <HighlightText text={"Math potential"} /> with PyVerse Academy
              </div>
            }
            subheading={
              "At PyVerse Academy, our Mathematics courses are designed to build strong conceptual understanding and problem-solving skills, taught by experienced instructors who simplify complex topics and help students master mathematical thinking."
            }
            ctabtn1={{
              btnText: "Try it Yourself",
              link: "/https://pyverse-quizz.netlify.app/",
              active: true,
            }}
            ctabtn2={{
              btnText: "Learn More",
              link: "/signup",
              active: false,
            }}
            codeColor={"text-yellow-25"}
            codeblock={`Math Solution
Solve: 2x² - 7x + 3 = 0

Step 1: Compare with ax² + bx + c = 0 <br>
a = 2, b = -7, c = 3

Step 2: Use quadratic formula <br>
x = (-b ± √(b² - 4ac)) / 2a

Step 3: Substitute values <br>
x = (7 ± √(49 - 24)) / 4 <br>
x = (7 ± √25) / 4

Step 4: Final values <br>
x = (7 + 5) / 4 = 3 <br>
x = (7 - 5) / 4 = 1/2
Final Answer: x = 3 or x = 1/2</b>`}
            backgroundGradient={<div className="codeblock1 absolute"></div>}
          />
        </div>

        {/* Code Section 2 */}
        <div>
          <CodeBlocks
            position={"lg:flex-row-reverse"}
            heading={
              <div className="w-[100%] text-4xl font-semibold lg:w-[50%]">
                Start
                <HighlightText text={"coding in seconds"} />
              </div>
            }
            subheading={
              "At PyVerse Academy, our Python courses are designed to develop strong programming skills through hands-on practice, real coding exercises, and guidance from experienced mentors. ahead, give it a try. Our hands-on learning environment means you'll be writing real code from your very first lesson."
            }
            ctabtn1={{
              btnText: "Continue Lesson",
              link: "https://pyverse-quizz.netlify.app/",
              active: true,
            }}
            ctabtn2={{
              btnText: "Learn More",
              link: "/signup",
              active: false,
            }}
            codeColor={"text-white"}
            codeblock={`import React from "react";\n import CTAButton from "./Button";\nimport TypeAnimation from "react-type";\nimport { FaArrowRight } from "react-icons/fa";\n\nconst Home = () => {\nreturn (\n<div>Home</div>\n)\n}\nexport default Home;`}
            backgroundGradient={<div className="codeblock2 absolute"></div>}
          />
        </div>
          <div>
          <CodeBlocks
            position={"lg:flex-row"}
            heading={
              <div className="text-4xl font-semibold">
                Unlock your
                <HighlightText text={"Science potential"} /> with PyVerse Academy
              </div>
            }
            subheading={
              "At PyVerse Academy, our Science classes focus on clear concepts, real-world examples, and practical understanding, guided by experienced teachers dedicated to making science engaging and easy to learn.Our courses are designed and taught by industry experts who have years of experience in coding and are passionate about sharing their knowledge with you."
            }
            ctabtn1={{
              btnText: "Try it Yourself",
              link: "https://pyverse-quizz.netlify.app/",
              active: true,
            }}
            ctabtn2={{
              btnText: "Learn More",
              link: "/signup",
              active: false,
            }}
            codeColor={"text-yellow-25"}
            codeblock={`Physics Problem

A ball is projected from the ground with an initial velocity of 20 m/s
at an angle of 30° with the horizontal.
Find the horizontal range of the projectile.
Take g = 9.8 m/s².
...................→★  → Max Height
...............→╭─╯╰─╮ 
.............→╭─╯....╰─╮
...........→╭─╯........╰─╮
.........→╭─╯............╰─╮
.......→╭─╯................╰─╮
.....→╭─╯....................╰─╮
O──.Launch point────────────────→Range
       

↗ u = 20 m/s
↗ θ = 30°
                → Max Height
Launch point               Range
   \
    \→ u = 20 m/s
     \→ θ = 30°
            → Max Height


Solution

Given:
u = 20 m/s
θ = 30°
g = 9.8 m/s²

Formula:
R = (u² sin2θ) / g

Step 1:
R = (20² × sin(2 × 30°)) / 9.8

Step 2:
R = (400 × sin60°) / 9.8

Step 3:
sin60° = 0.866

Step 4:
R = 346.4 / 9.8

R ≈ 35.35 m

Final Answer:
Range ≈ 35.3 m`}
            backgroundGradient={<div className="codeblock1 absolute"></div>}
          />

  {/* Code Section 4 */}
        <div>
          <CodeBlocks
            position={"lg:flex-row-reverse"}
            heading={
              <div className="w-[100%] text-4xl font-semibold lg:w-[50%]">
                Start
                <HighlightText text={"AI/ ML/ CS/ IT With PyVerse"} />
              </div>
            }
            subheading={
              "At PyVerse Academy, students learn the fundamentals of Artificial Intelligence and Machine Learning through practical projects, logical thinking, and expert guidance to prepare them for future technologiest PyVerse Academy, our Python courses are designed to develop strong programming skills through hands-on practice, real coding exercises, and guidance from experienced mentors. ahead, give it a try. Our hands-on learning environment means you'll be writing real code from your very first lesson."
            }
            ctabtn1={{
              btnText: "Continue Lesson",
              link: "https://pyverse-quizz.netlify.app/",
              active: true,
            }}
            ctabtn2={{
              btnText: "Learn More",
              link: "/signup",
              active: false,
            }}
            codeColor={"text-white"}
            codeblock={`import React from "react";\n import CTAButton from "./Button";\nimport TypeAnimation from "react-type";\nimport { FaArrowRight } from "react-icons/fa";\n\nconst Home = () => {\nreturn (\n<div>Home</div>\n)\n}\nexport default Home;`}
            backgroundGradient={<div className="codeblock2 absolute"></div>}
          />
        </div>
          <div></div>         
        </div>


        {/* Explore Section */}
        <ExploreMore />
      </div>

      {/* Section 2 */}
      <div className="bg-pure-greys-5 text-richblack-700">
        <div className="homepage_bg h-[320px]">
          {/* Explore Full Catagory Section */}
          <div className="mx-auto flex w-11/12 max-w-maxContent flex-col items-center justify-between gap-8">
            <div className="lg:h-[150px]"></div>
            <div className="flex flex-row gap-7 text-white lg:mt-8">
              <CTAButton active={true} linkto={"https://allcobexam.netlify.app/"}>
                <div className="flex items-center gap-2">
                  Coochbehar Live Test
                  <FaArrowRight />
                </div>
              </CTAButton>
              <CTAButton active={false} linkto={"https://pyverse-quizz.netlify.app/"}>
                Practice test
              </CTAButton>
            </div>
          </div>
        </div>

        <div className="mx-auto flex w-11/12 max-w-maxContent flex-col items-center justify-between gap-8 ">
          {/* Job that is in Demand - Section 1 */}
          <div className="mb-10 mt-[-100px] flex flex-col justify-between gap-7 lg:mt-20 lg:flex-row lg:gap-0">
            <div className="text-4xl font-semibold lg:w-[45%] ">
              Get the Knowledge you need for a{" "}
           <HighlightText text={"successful future with Pyverse Academy"} />
            </div>
            <div className="flex flex-col items-start gap-10 lg:w-[40%]">
              <div className="text-[16px]">
                At PyVerse Academy, we believe learning should go beyond textbooks. Our goal is to help students master Math, Science, AI, and Python while developing the confidence and skills needed for future success.
              </div>
              <CTAButton active={true} linkto={"/signup"}>
                <div className="">Learn More</div>
              </CTAButton>
            </div>
          </div>

          {/* Timeline Section - Section 2 */}
          <TimelineSection />

          {/* Learning Language Section - Section 3 */}
          <LearningLanguageSection />
        </div>
      </div>

      {/* Section 3 */}
      <div className="relative mx-auto my-20 flex w-11/12 max-w-maxContent flex-col items-center justify-between gap-8 bg-richblack-900 text-white">
        {/* Become a instructor section */}
        <InstructorSection />

        {/* Reviws from Other Learner */}
        <h1 className="text-center text-4xl font-semibold mt-8">
          Reviews from other learners
        </h1>
        <ReviewSlider />
      </div>

      {/* Footer */}
      <Footer />

       {
        confirmationModal &&
        <ConfirmationModal
        modalData={confirmationModal} 
       />
      }
    </div>
  )
}

export default Home
